import type { FaireProductEntity } from "../../entity_types/product";

export const p_mwgx83zgkh: FaireProductEntity = {
  token: "p_mwgx83zgkh",
  type: "product",
  name: "Tiki 19 oz. Recycled Glass",
  brandName: "Hospitality Glass",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bf53088a036099e9e107c0bc46963b067061183beeec4fb1a7388f6f496b6bb0.png",
  priceDollars: 3.97,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/22255ec01b6063498142712f464e8195d3c0edb4be71cb3d49d77738ac1be22d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
